/*
 * @author: pengjun
 * @date: 2024-12-13
 * @lastEditors: pengjun
 * @lastEditTime: 2025-09-16
 * @description:
 */
import React from 'react';
import { Button } from 'antd';
import './index.scss';
import { envConfig } from '@/config/common';

function WebsiteFooter() {
  const toRegister = () => {
    const prefix = location.protocol + '//' + envConfig.SERVICE_SECOND_DOMAIN;
    location.href = prefix + '#/sys/register';
  };

  return (
    <div className="website-footer">
      <Button type="primary" className="open-btn" onClick={toRegister}>
        0元开店
      </Button>
    </div>
  );
}

export default WebsiteFooter;
